export default "__VITE_ASSET__4cc647bf__"